export default "__VITE_ASSET__BKcPl0Nn__"